export default __webpack_public_path__ + "static/media/Inter-ExtraLight.9a8c0250.woff";